import { useState, useEffect, useLayoutEffect } from "react";
import { useNavigate } from "react-router-dom";

import EmployeeSidebar from "../../components/Dashboard/EmployeeSidebar";
import { Button } from "../../components/Shared/Button";

import { fetchLessons } from "../../api/lessons/students";
import { fetchEnrolledCourses, fetchCourse } from "../../api/courses/students";

import placeholderImage from "../../images/placeholder.png";
import cardPlaceholderImg from "../../images/image.png";

import Navbar from "../../components/Navbar"

import "./index.css";

function OngoingEmployeeCourses() {
  const navigate = useNavigate();
  const [ongoingCourses, setOngoingCourses] = useState([]);
  const [enrolledCourses, setEnrolledCourses] = useState([]);
  useEffect(async () => {
    try {
      const res = await fetchEnrolledCourses();
      setEnrolledCourses(res);
    } catch (err) { // TODO: handle error
      console.log(err)
    }
  }, []);

  useEffect(async () => {
    const lessonApiCalls = [];
    const courseApiCalls = [];
    enrolledCourses.forEach((c) => {
      courseApiCalls.push(fetchCourse(c.id));
      lessonApiCalls.push(fetchLessons(c.id))
    });
    try {
      const arr = [];
      const coursesRes = await Promise.all(courseApiCalls);
      const lessonsRes = await Promise.all(lessonApiCalls);
      coursesRes.forEach((c, i) => {
        arr.push({
          course_id: c.id,
          lesson_id: lessonsRes[i][0].id,
          ...c,
        })
      });
      setOngoingCourses(arr);
    } catch (err) {
      console.log(err);
    }
  }, [enrolledCourses]);

  return (
    ongoingCourses.map(({
      course_id, lesson_id, title, author_name, pretty_created_at, hero_image_url, author_profile_image_url,
    }) => {
      return (
        <div className="OngoingEmployeeCourse">
          <div className="Card">
            <div
              className="CardImg"
              style={{backgroundImage: `url(${hero_image_url || cardPlaceholderImg})`}}
            />
            <div className="CardTitle">{title}</div>
            <div className="CardAuthorInfoContainer">
              <div
                style={{
                  backgroundImage: `url(${author_profile_image_url || placeholderImage})`
                }}
                className="CardAurthorProfileImg"
              />
              <div className="CardAuthorInfo">
                <div className="CardAuthorName">
                  <span>By</span>
                  <span>{author_name}</span>
                </div>
                <div className="CardDate">
                  {pretty_created_at.split(".").join("-")}
                </div>
              </div>
            </div>
            <div className="OngoingEmployeeCourseAction">
              <Button
                text="Open"
                onClick={() => navigate(`/courses/${course_id}/lessons/${lesson_id}`)}
              />
            </div>
          </div>
        </div>
      )
    })
  )
}

function Ongoing() {
  useEffect(() => document.body.style.backgroundColor = "#F5F5F5", []);
  useLayoutEffect(() => { return () => document.body.style.backgroundColor = null }, []);
  return (
    <div className="OngoingEmployeeCoursesMainContainer">
      <EmployeeSidebar />
      <Navbar />
      <div className="OngoingEmployeeCoursesContainer">
        <div className="OngoingEmployeeCoursesHeader">My Courses</div>
        <div className="OngoingEmployeeCourses">
          <OngoingEmployeeCourses />
        </div>
      </div>
    </div>
  )
}

export default Ongoing;
